import DashboardSection from "./DashboardSection";

import "./CoachWorkload.css";

export default function CoachWorkload({ items = [] }) {
  return (
    <DashboardSection title="Coach workload" description="Dossiers per coach.">
      <div className="coach-workload">
        {items.length === 0 ? (
          <div className="coach-workload__empty">Geen coachgegevens.</div>
        ) : (
          items.map((item) => (
            <div
              key={item.coach?._id || item._id}
              className="coach-workload__row"
            >
              <div>
                <strong>{`${item.first_name} ${item.last_name}`}</strong>

                <span>{item.coach?.email || item.email || "-"}</span>
              </div>

              <strong>{item.count}</strong>
            </div>
          ))
        )}
      </div>
    </DashboardSection>
  );
}
